/**
 * Configuration globale pour l'API
 */

interface ApiConfig {
  timeout: number;
  withCredentials: boolean;
}

interface EnvironmentConfigs {
  development: ApiConfig;
  production: ApiConfig;
  test: ApiConfig;
}

const ENV = (import.meta.env.MODE || "development") as keyof EnvironmentConfigs;

const config: EnvironmentConfigs = {
  development: {
    timeout: 30000,
    withCredentials: true,
  },
  production: {
    timeout: 30000,
    withCredentials: true,
  },
  test: {
    timeout: 5000,
    withCredentials: true,
  },
};

export default {
  ...config[ENV],
};
